export default "__VITE_ASSET__D3Gq7JqR__"